import { render, staticRenderFns } from "./IndexTab.vue?vue&type=template&id=5ee3ae90&scoped=true&"
import script from "./IndexTab.vue?vue&type=script&lang=js&"
export * from "./IndexTab.vue?vue&type=script&lang=js&"
import style0 from "./IndexTab.vue?vue&type=style&index=0&id=5ee3ae90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee3ae90",
  null
  
)

export default component.exports